import { Link } from "react-router-dom";

// Metro-map breadcrumb: "You're on the <line> line, which joins <stops>".
export const MetroLineNote = ({ line, colour, stops, testId }) => (
  <p className="mb-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-stone-600" data-testid={testId}>
    <span aria-hidden className="inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: colour }} />
    <span>You're on the {line} line, which joins</span>
    {stops.map((s, i) => (
      <span key={s.to} className="inline-flex items-center gap-x-2">
        {i > 0 && <span>and</span>}
        <Link to={s.to} style={{ color: colour }} data-testid={s.testId}
          className="font-medium underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-current">
          {s.label}
        </Link>
      </span>
    ))}
  </p>
);
